var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tags--select" }, [
    _vm.create_modal
      ? _c("section", [
          _c(
            "div",
            {
              staticClass: "modal fade",
              attrs: {
                id: "tag--create-modal",
                tabindex: "-1",
                role: "dialog",
                "aria-labelledby": "myModalLabel",
                "aria-hidden": "true"
              }
            },
            [
              _c(
                "div",
                { staticClass: "modal-dialog", attrs: { role: "document" } },
                [
                  _c("div", { staticClass: "modal-content" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "modal-body mx-3" },
                      [
                        _c("name_to_slug", {
                          ref: "tag_name_slug",
                          attrs: { content: _vm.content.name_to_slug }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "md-form" }, [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.tag_create_description,
                                expression: "tag_create_description"
                              }
                            ],
                            staticClass: "md-textarea",
                            attrs: { id: "tag--create-description" },
                            domProps: { value: _vm.tag_create_description },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.tag_create_description = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              attrs: {
                                "data-error": "wrong",
                                "data-success": "right",
                                for: "tag--create-description"
                              }
                            },
                            [_vm._v("Description")]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { attrs: { id: "icon-chooser--wrapper" } },
                          [
                            _c("icon_chooser", {
                              ref: "tag_icon",
                              attrs: {
                                icons_url: _vm.content.icon_chooser.icons_url,
                                input_field:
                                  _vm.content.icon_chooser.input_field
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "modal-footer d-flex justify-content-center"
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-default",
                            on: {
                              click: function($event) {
                                _vm.createTag()
                              }
                            }
                          },
                          [_vm._v("Create")]
                        )
                      ]
                    )
                  ])
                ]
              )
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("section", [
      _c("div", [
        _c(
          "div",
          { attrs: { id: "material_select--wrapper" } },
          [
            _c("material-select", {
              ref: "tags_chooser_select",
              attrs: {
                id: _vm.tags_chooser.id,
                select_input_id: _vm.tags_id_for_chooser
              },
              on: {
                material_select_result: _vm.materialSelectItemSelected,
                material_select_link_click: _vm.materialSelectCreateTag
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header text-center" }, [
      _c("h4", { staticClass: "modal-title w-100 font-bold" }, [
        _vm._v("Create Tag")
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f7d7ef0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f7d7ef0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/forms/Tags.vue
// module id = 409
// module chunks = 0